import { Fragment, useEffect, useState } from "react";
import { TitleHeader } from "../../components/commons";
import { Form, Button, Select, Input, notification, Switch } from "antd";
import { executeUpdate, isRequestPasswordEnabled } from "../../api/sistema";
import { storeParticipanteAcount } from "../../api/participante";
import * as SHARED from "../../utils/shared";

const { Option } = Select;

function Configuracion() {
  const [isLoading, setIsLoading] = useState(false);
  const [dataToPage, setDataToPage] = useState({ asistenciaEnabled: false });
  const [isSending, setIsSending] = useState(false);

  const fetchDataToPage = async () => {
    setIsLoading(true);

    isRequestPasswordEnabled()
      .then((res) => {
        setDataToPage(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = (values) => {
    const { email, idmodalidad } = values;
    const modalidad = SHARED.MODALIDADES.find((i) => i.value === idmodalidad);

    sendPassword({
      email,
      idtipoparticipante: modalidad.idtipoparticipante,
      idtipoparticipacion: modalidad.idtipoparticipacion
    });
  };

  const sendPassword = async (data) => {
    try {
      setIsSending(true);
      const response = await storeParticipanteAcount(data);
      if (response) {
        notification.success({ message: "Operación exitosa", description: response.message });
      }
    } catch (err) {
      notification.error({ menssage: "Operación fallida", description: err.message });
    } finally {
      setIsSending(false);
    }
  };

  const onChangeState = (value) => {
    executeUpdate(
      {
        collection: "config",
        nombreid: "configId",
        valorid: "configId"
      },
      {
        activoSolicitaContrasenia: value
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha guardado la configuración satistactoriamente.`
          });
          fetchDataToPage();
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo actualizar el estado, comuníquese con el administrador.`
        });
      });
  };

  return (
    <Fragment>
      <TitleHeader title="Configuración" />

      <div className="w-full mb-6 md:w-1/4">
        <p className="font-semibold mb-3">Solicitar contraseña habilitado</p>
        <Switch
          checked={dataToPage.activoSolicitaContrasenia}
          onChange={onChangeState}
          loading={isLoading}
        />
      </div>

      <hr />

      <TitleHeader title="Registrar participante" />

      <div className="w-full mb-6 md:w-1/4">
        <Form initialValues={{ remember: true }} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="email"
            label="Correo electrónico institucional"
            rules={[{ required: true, message: "El correo electrónico es necesario" }]}
          >
            <Input type="email" />
          </Form.Item>

          <Form.Item
            name="idmodalidad"
            label="Seleccione una modalidad"
            rules={[{ required: true, message: "Este campo es requerido" }]}
          >
            <Select placeholder="Seleccione una opción" className="text-base">
              {SHARED.MODALIDADES.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" block htmlType="submit" loading={isSending}>
              Registrar participante
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Fragment>
  );
}

export default Configuracion;
